// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TokensPercentage/index.css
// module id = 2316
// module chunks = 0